import React, { Component } from 'react'
import { FaWallet, FaMoneyBillWave, FaFileDownload , FaCheck} from "react-icons/fa";
import PageHeaderWrapper from '../../../components/PageHeaderWrapper'
import TableComp from '../../../components/_utils/table'
import {hideLoader, showLoader} from '../../../modules/actions'
import { Button, Card, DatePicker, Row, Col, notification, Select, Icon, Tooltip, Popconfirm } from 'antd'
import Request from '../../../request'
import { connect } from 'react-redux'
import _ from 'lodash'
import styles from './styles.less'
const Option = Select.Option

class PaymentDesk extends Component {

    state = {
        count: 0,
        countryArr: [],
        users: [],
        time: {
            key: 'updatedByUser.time',
            from: null,
            to: null
        },
        loading: false,
        records: [],
        user: '',
        userId: '',
        universityId: '',
        selectedUserId: "",
    }
    searchParams = new URLSearchParams(window.location.search); 

    constructor(props) {
        super(props)
        this.table = React.createRef()
    }

    async componentDidMount() {
    
        if (!this.searchParams.get('id')) {
            this.loadUsers();
        }
    }


    apiRequest = (params, columns) => {
        return new Promise(async resolve => {
            
            if (!params.sortField) {
                params.sortField = 'createdByUser.time'
                params.sortOrder = 'descend'
                params.page = 1
            }

            if (this.state.userId) {
                params.userId = this.state.userId;
            }

            const payload = {
                ...params,
            }
            let data = await Request.getInvoicePayments(payload)

            delete data.error
            delete data.type

            this.setState({ count: data.total })
            
            resolve(data)
        })
    }

    onUserChoose = (userId) => {
        this.setState({ userId: userId }, () => {
            this.table.current.reload();
        });
    };

    loadUsers = () => {

        Request.getPaymentDeskUsers({})
            .then(resp => {
                let temp = []
                _.each(resp, (vv) => {
                    temp.push({
                        text: vv.name,
                        value: vv._id
                    })
                })

                this.setState({ users: temp })
            })
            .catch(err => {
                console.log(err)
            })
    }

    handlePaymentPaid = async (payload) => {

        const {dispatch} = this.props

        dispatch(showLoader());

        let x = await Request.paidPaymentDesk(payload)

        dispatch(hideLoader())

        if (!x.error) {
            this.reload();
            notification.success({
                message: 'Success',
                description: x.msg
            })

        } else {
            notification.error({
                message: 'Error Saving',
                description: x.msg
            })
        }
    }

    handlePaymentDeskPDF = async (userId) => {
      
        const {dispatch} = this.props
        dispatch(showLoader())
        const exportParams = {userId:userId};
        let x = await Request.paymentdeskPDF({
            ...exportParams,
            regExFilters: []
        })
        dispatch(hideLoader())

        if (!x.error) {
            window.open(x.url, '_blank')
        } else {
            notification.error({
                message: 'Error Saving',
                description: x.msg
            })
        }
    }

    onOk = value => {
        this.reload()
    }
    reload = () => {
        this.table.current.reload()
    }

    columns = [
        {
            title: 'User Name',
            key: 'userName',
            dataIndex: 'userName',
            width: 100
        },
        {
            title: 'Total Amount',
            key: 'invoicePaymentDeskAmount',
            dataIndex: 'invoicePaymentDeskAmount',
            width: 100
        },
        {
            title: 'Action',
            key: 'operation',
            dataindex: 'operation',
            width: 130,
            render: (text, record) => (
                <div className={styles.wrap}>

                    <Tooltip title="Paid">
                    <Popconfirm
                                    title="Have you paid?"
                                    onConfirm={() => {
                                        this.handlePaymentPaid({_id: record._id})
                                    }}
                                    onCancel={() => {
                                        console.log()
                                    }}
                                    okText="Yes"
                                    cancelText="No">
                                   <Button
                            className={styles.btn}
                            size={'small'}
                            shape="circle"><FaCheck/></Button>
                    </Popconfirm>
                    </Tooltip>

                    <Tooltip title="Download">
                    <Button
                            className={styles.btn}
                            size={'small'}
                            shape="circle"
                            onClick={() => this.handlePaymentDeskPDF(record._id)}
                        ><FaFileDownload/></Button>
                    </Tooltip>
                </div>
            )
        }
    ]

    render() {
        

        const { users } = this.state;
        return (
            <PageHeaderWrapper title={`PAYMENT DESK : ${this.state.count} `}>

                <Card style={{ marginBottom: 10 }}>
                
                    <Row style={{ marginTop: 10 }}>
                        
                
                            <Col span={7}>
                            <Select
                                        showSearch={true}
                                        allowClear={true}
                                        placeholder="Select User Name"
                                        style={{ width: "200px" }}
                                        className={'knowledge-base-input'}
                                        onChange={this.onUserChoose}
                                        filterOption={(input, option) => {
                                            return (
                                                option.props.children
                                                    .toLowerCase()
                                                    .indexOf(input.toLowerCase()) >= 0
                                            );
                                        }}
                                    >
                                        {users.map((item, key) => {
                                            return (
                                                <Option key={key} value={item.value}>{item.text}</Option>
                                            )
                                        })}
                                    </Select>
                            </Col> 
                      
                       
                    </Row>


                </Card>

                <Card bordered={true}>
                    <TableComp
                        showSelector={true}
                        columns={this.columns}
                        ref={this.table}
                        apiRequest={params => this.apiRequest(params)}
                        extraProps={{ scroll: { x: 1500 } }}
                        pagination={{
                            showSizeChanger: true,
                            defaultPageSize: 20,
                            pageSizeOptions: ['10', '20', '50', '100', '1000']
                        }}
                    />
                </Card>
            </PageHeaderWrapper>
        )
    }
}

const mapStateToProps = ({ global }) => ({
    categories: global.categories,
    currentUser: global.currentUser,
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}

export default PaymentDesk = connect(
    mapStateToProps,
    mapDispatchToProps
)(PaymentDesk)